
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1kjc7_5quth_13",
  "root": "awsui_root_1kjc7_5quth_27",
  "title": "awsui_title_1kjc7_5quth_62",
  "list": "awsui_list_1kjc7_5quth_66",
  "marker--dimmed": "awsui_marker--dimmed_1kjc7_5quth_114",
  "marker--highlighted": "awsui_marker--highlighted_1kjc7_5quth_117"
};
  